export default "__VITE_ASSET__4QXa0ItO__"